module.exports = __webpack_public_path__ + "static/media/vipcardlogo.d51bbfd5.svg";